import { create } from 'zustand';

import {
  getSelectedMonth,
  provideMonthsToRender,
  updateMonthsToRender,
} from '@calendar/calendarHelpers';
import { MonthToRenderState } from '@calendar/types/MonthsToRender';

const useMonthsToRenderStore = create<MonthToRenderState>((set, get) => ({
  monthsToRender: get()?.monthsToRender || provideMonthsToRender(),
  selectedMonth: getSelectedMonth(
    get()?.monthsToRender || provideMonthsToRender(),
  ),
  setSelectedMonth: (selectedMonth) => set({ selectedMonth }),
  setMonthsToRender: (targetMonthIndex, isSelectPrevious = false) =>
    set((prev) => ({
      monthsToRender: updateMonthsToRender(
        prev.monthsToRender,
        targetMonthIndex,
        isSelectPrevious,
      ),
    })),
}));

export default useMonthsToRenderStore;
